import Skeleton from 'components/Skeleton/Skeleton';
import React, { FC } from 'react';
import AttributeHeader, { AttributeHeaderProps } from '../AttributeHeader';
import clsx from 'clsx';

interface LoadingProps extends AttributeHeaderProps {
  size?: 'small' | 'large';
  numberOfSkeletons?: number;
}

const Loading: FC<LoadingProps> = ({
  size = 'small',
  numberOfSkeletons = 2,
  ...attributeHeaderProps
}) => {
  return (
    <>
      <AttributeHeader {...attributeHeaderProps} />
      <div className="flex flex-col gap-4 pl-6 pr-4">
        {Array.from({ length: numberOfSkeletons || 2 }).map((_, index) => (
          <Skeleton
            key={index}
            animate
            className={clsx('w-full', {
              'h-14': size === 'small',
              'h-[94px]': size === 'large',
            })}
          />
        ))}
      </div>
    </>
  );
};

export default Loading;
